"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { CrossIcon } from "../../icons/index.js";
import makeStyles from "../../theming/make-styles.js";
import { IconButton } from "../button/index.js";
import { DialogContext } from "./dialog.js";
const useStyles = makeStyles()((theme, { closable, color }) => {
    const palette = theme.palette(color).dialog;
    return {
        close: {
            alignSelf: "flex-start",
            justifySelf: "flex-end",
        },
        header: {
            "position": "sticky",
            "top": 0,
            "zIndex": 1,
            "display": "grid",
            "gridTemplateColumns": "1fr auto",
            "alignItems": "center",
            "justifyContent": "space-between",
            "padding": closable ? theme.spacing("md", "md", "md", "lg") : theme.spacing("md", "lg"),
            "backgroundColor": "inherit",
            "borderBottom": `${theme.size(1)} solid ${palette.header.borderBottomColor}`,
            "& h3": {
                margin: 0,
            },
        },
    };
});
export const DefaultCloseButton = React.forwardRef(function DefaultCloseButton(props, ref) {
    return _jsx(IconButton, Object.assign({ ref: ref, color: "gray", icon: CrossIcon, round: true, size: "small", variant: "link" }, props));
});
export const DialogHeader = React.forwardRef(function DialogHeader(_a, ref) {
    var { children, className, closeButton: CloseButton = DefaultCloseButton, color = "primary" } = _a, props = __rest(_a, ["children", "className", "closeButton", "color"]);
    const { closable, onClose } = useContext(DialogContext);
    const { classes, cx } = useStyles({ closable, color });
    return (_jsxs("div", Object.assign({ ref: ref, className: cx(classes.header, className) }, props, { children: [typeof children === "string" ? _jsx("h3", { children: children }) : children, closable && _jsx(CloseButton, { className: classes.close, onClick: onClose })] })));
});
export default DialogHeader;
//# sourceMappingURL=dialog-header.js.map